export default {
  standard: ['G4', 'C4', 'E4', 'A4']
};